<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">PINGS</li>
                </ol>

                <div class="page-header">
                    <h1 id="navbar">Pontos</h1>
                </div>

                <div class="row">
                    <div v-bind:key="p.ssh.host" class="col-lg-4" v-for="p in pontos" v-if="p.ssh.host">
                        <div class="bs-component">
                            <div :class="{'alert-danger': !p.ping, 'alert-success': p.ping}" class="alert alert-dismissible ">
                                <strong>{{p.nome}}</strong><br/> {{p.ssh.host}}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { Pontos } from "../../class/pontos";
/* global io */
export default {
    data() {
        return {
            pontos: [],
            socket: null,
            interval: null
        };
    },
    async beforeMount() {
        this.socket = io.connect(
            this.$http.options.root,
            { reconnect: true, transports: ["websocket", "polling"] }
        );
        this.socket.on("ping-status", data => {
            console.log(data);
            this.pontos.forEach(valor => {
                if (data.ip === valor.ssh.host) {
                    valor.ping = data.data;
                }
            });
        });
        this.interval = setInterval(this.pingar, 20000);

        this.pontos = await Pontos.all();

        this.pontos.forEach(p => (p.ping = true));

        this.pingarPontos();
    },
    methods: {
        pingar() {
            if (this.ip) {
                this.socket.emit("pingIN", { ip: this.ip });
            }
        },
        pingarPontos() {
            this.pontos.forEach(f => {
                if (f.ssh.host) {
                    this.socket.emit("pingIN", { ip: f.ssh.host });
                }
            });
        }
    },

    beforeDestroy() {
        clearInterval(this.interval);
        this.socket.close();
    }
};
</script>
